import styled from 'styled-components';
import color from '../../../config/colors.json';

export const StyledLoader = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  
  i {
    font-size: 3em;
    color: ${color.darkGrey2};
  }
`;

export const StyledLoaderPdf = styled.div`
  width: 100%;
  height: 100%;
  display: contents;
  justify-content: center;
  align-items: center;
  
  i {
    font-size: 1em;
    color: ${color.cyan};
  }
`;

export const StyledLoaderReports = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: ${color.darkGrey2};
  
  h4 {
    font-family: Poppins-Medium, Heltica, Arial, sans-serif;
    font-size: 24px;
  }
  
  p {
    font-family: Poppins, Heltica, Arial, sans-serif;
    font-size: 18px;
  }
`;

export const StyledLoaderMain = styled.div`
  min-height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  
  h2 {
    font-family: Poppins-Semi-Bold, sans-serif;
    font-size: 36px;
    color: ${color.darkGrey2};
    margin-top: 5px;
    margin-bottom: -5px;
  }
  
  p {
    font-family: Poppins, Heltica, Arial, sans-serif;
    font-size: 25px;
    color: ${color.grey};
  }  
  
  .cockpit-load__icon {
    width: 128px;
    height: 128px;
    display: inline-block;
    stroke: ${color.lightGrey3};
    stroke-width: 1px;
    stroke-dashoffset: 260px;
    stroke-dasharray: 260px;  
    
    * {
      fill: transparent;
    }
    
    .st0 {
      webkit-animation: cockpit-load-icon-circle 3s infinite;
      animation: 5000ms ease 0ms infinite normal none running cockpit-load-icon-circle;
    }
    
    @keyframes cockpit-load-icon-circle {
      0% {
        stroke-dashoffset: 260px;
        fill: transparent;
      }
      79% {
        stroke-dashoffset: 0;
        fill: transparent;
      }
      80% {
        stroke-dashoffset: 260px;
        fill: red;  
      }
      100% {
        stroke-dashoffset: 260px;
        fill: red;
      }
    }
  }  
`;

export const StyledLoaderLogos = styled.div`
  width: 150px;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  
  i {
    font-size: 1rem;
    color: ${color.darkGrey2};
  }
`;

export const StyledDefaultLoader = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;

  i {
    font-size: 2rem;
    color: ${({ fill }) => (fill || color.light)};
  }
`;


export const StyledOverlayLoader = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: ${color.light};
  opacity: 0.94;
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  i {
    font-size: 40px;
    color: ${color.lightRed3};
    margin-bottom: 27px;
  }

  span {
    font-size: 15px;
    color: ${color.darkGrey}
  }
`;
